import { useRef, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import { useRaf, useResize } from '@/components/Handlers'
import DelayLink from '@/components/DelayLink'
import style from './style'

const useStyles = createUseStyles(style)

const RailText = ({
  className,
  title,
  link,
  reverse,
  image,
  label,
}) => {
  const classes = useStyles()
  const rootRef = useRef()
  const containerRef = useRef()
  const containerWidth = useRef()
  const ticker = useRef(0)

  const calculateWidth = useCallback(() => {
    containerWidth.current = containerRef.current?.offsetWidth || 0
  })

  useEffect(() => {
    calculateWidth()
  }, [])

  useResize(() => {
    calculateWidth()
  })

  useRaf(() => {
    ticker.current += 1
    rootRef.current.style.transform = `translate3d(${!reverse ? '-' : ''}${ticker.current}px, 0px, 0px)`
    if (containerWidth.current <= ticker.current) ticker.current = 0
  })

  const renderImage = () => (
    <div className={classes.image}>
      <div style={{ backgroundImage: `url(${image})` }} />
    </div>
  )

  const renderText = (text) => (
    <span dangerouslySetInnerHTML={{ __html: text }} />
  )

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.reverse]: reverse,
        [className]: className,
      })}
    >
      <div
        ref={rootRef}
        className={classes.groupContainer}
      >
        {Array(2).fill(title).map((it, i) => (
          <div
            key={i} // eslint-disable-line
            ref={containerRef}
            className={classes.railContainer}
          >
            {Array(2).fill(title).map((item, i) => ( // eslint-disable-line
              <div
                key={i} // eslint-disable-line
                className={classes.railTrack}
              >
                <div className={classes.text}>
                  <DelayLink
                    className={classes.label}
                    to={link}
                  >
                    {renderText(label)}
                  </DelayLink>
                  {(image && link) && (
                    <DelayLink to={link}>
                      {renderImage()}
                    </DelayLink>
                  )}
                  {(image && !link) && renderImage()}
                  {link ? (
                    <DelayLink
                      className={classes.title}
                      to={link}
                    >
                      {renderText(item)}
                    </DelayLink>
                  ) : renderText(item)}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

RailText.defaultProps = {
  reverse: false,
}

export default RailText
